module.exports = __webpack_public_path__ + "img/username_guang.f9f23e82.jpg";